import { useState } from "react";

function AddWorkerModal({ show, onClose, onNameChange, onRolesChange, onAddWorker, selectedCompany }) {
  const [workerName, setWorkerName] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [roles, setRoles] = useState('');

  const handleSave = () => {
    if(!workerName.trim() || !roles.trim()) {
      alert('Please fill out all fields');
      return;
    }
    
    onNameChange(workerName);
    onRolesChange(roles); 
    
    const newWorker = {
      workerName,
      roles: roles.split(',').map(role => role.trim())
    };
    onAddWorker(newWorker);
  };
  
  return (
    show && (
      <div className="modal">
        <div className="modal-content">
            <h1>Tilføj medarbejder til {selectedCompany}</h1>
          <span className="close" onClick={onClose}>&times;</span>
          <label>Medarbejders navn</label>
          <input type="text" value={workerName} onChange={(e) => setWorkerName(e.target.value)} />
          <label>Roller. komma mellem hver rolle.</label>
          <input type="text" value={roles} onChange={(e) => setRoles(e.target.value)} />
          <button onClick={handleSave}>Tilføj</button>
        </div>
      </div>
    )
  );
}

export default AddWorkerModal;
